"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _Table = _interopRequireDefault(require("../../preact-components/table/Table"));

var _happy = _interopRequireDefault(require("../../preact-components/topic-helpfulness/assets/happy"));

var _confused = _interopRequireDefault(require("../../preact-components/topic-helpfulness/assets/confused"));

var _weary = _interopRequireDefault(require("../../preact-components/topic-helpfulness/assets/weary"));

var _Loader = require("./Loader");

var _EmptyTable = _interopRequireDefault(require("./EmptyTable"));

var _EmptyResults = require("./EmptyResults");

var _assets = _interopRequireDefault(require("../../preact-components/assets"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PopularTopicsTable = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PopularTopicsTable, _Component);

  var _super = _createSuper(PopularTopicsTable);

  function PopularTopicsTable(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PopularTopicsTable);
    _this = _super.call(this, props);

    _this.setState({
      popularTopics: [],
      sorting: {
        order: 'views',
        direction: 'desc'
      },
      isLoading: true
    });

    return _this;
  }

  (0, _createClass2.default)(PopularTopicsTable, [{
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(prevProps) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.props.startDate !== prevProps.startDate || this.props.endDate !== prevProps.endDate || this.props.selectedRoles !== prevProps.selectedRoles || this.props.selectedContentTypes !== prevProps.selectedContentTypes || this.props.selectedCategories !== prevProps.selectedCategories)) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.fetchPopularTopics(this.state.sorting);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidUpdate(_x) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "fetchPopularTopics",
    value: function () {
      var _fetchPopularTopics = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(sorting) {
        var res;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setState({
                  isLoading: true,
                  sorting: sorting
                });
                _context2.prev = 1;
                _context2.next = 4;
                return this.props.fetchData('/analyticsV2/fetchPopularTopics', {
                  sortOrder: sorting.order,
                  sortDirection: sorting.direction
                });

              case 4:
                res = _context2.sent;
                this.setState({
                  popularTopics: res.data,
                  isLoading: false
                });
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);
                this.setState({
                  isLoading: false
                });

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 8]]);
      }));

      function fetchPopularTopics(_x2) {
        return _fetchPopularTopics.apply(this, arguments);
      }

      return fetchPopularTopics;
    }()
  }, {
    key: "contentTypeCell",
    value: function contentTypeCell(topic) {
      switch (topic.content_type) {
        case 'question':
          return 'Question';

        case 'article':
          return 'Article';

        case 'productUpdate':
          return 'Product update';

        case 'idea':
          return 'Idea';

        case 'discussion':
          return 'Conversation';

        default:
          return 'Unrecognized type';
      }
    }
  }, {
    key: "helpfulnessCell",
    value: function helpfulnessCell(topic) {
      if (!topic) {
        return '';
      }

      var helpfulnessScore = topic.helpfulnessScore < 0 ? '-' : "".concat(topic.helpfulnessScore, "%");
      return (0, _preact.h)("div", {
        className: "helpfulness"
      }, (0, _preact.h)("div", null, helpfulnessScore), (0, _preact.h)("div", null, topic.helpful, " ", (0, _preact.h)(_happy.default, null)), (0, _preact.h)("div", null, topic.neutral, " ", (0, _preact.h)(_confused.default, null)), (0, _preact.h)("div", null, topic.notHelpful, " ", (0, _preact.h)(_weary.default, null)));
    }
  }, {
    key: "getModel",
    value: function getModel() {
      return [{
        header: 'Title',
        accessor: 'title',
        cell: function cell(topic) {
          return (0, _preact.h)("a", {
            href: (0, _absoluteUrlRuntime.resolveUrl)("/".concat(topic.url))
          }, topic.title);
        },
        size: 'm'
      }, {
        header: 'Content type',
        accessor: 'content_type',
        cell: this.contentTypeCell,
        size: 's-right',
        sorting: 'content_type'
      }, {
        header: 'Views',
        accessor: 'views',
        size: 'xs-right',
        cell: function cell(topic) {
          return (0, _preact.h)("span", null, topic.views, (0, _preact.h)(_assets.default, {
            customClass: "popular_topic_icon",
            icon: "eye",
            size: 16
          }));
        },
        sorting: 'views'
      }, {
        header: 'Replies',
        accessor: 'replies',
        size: 'xs-right',
        cell: function cell(topic) {
          return (0, _preact.h)("span", null, topic.replies, (0, _preact.h)(_assets.default, {
            customClass: "popular_topic_icon",
            icon: "reply",
            size: 16
          }));
        },
        sorting: 'replies'
      }, {
        header: 'Likes',
        accessor: 'likes',
        size: 'xs-right',
        cell: function cell(topic) {
          return (0, _preact.h)("span", null, topic.likes, (0, _preact.h)(_assets.default, {
            customClass: "popular_topic_icon",
            icon: "like",
            size: 16
          }));
        },
        sorting: 'likes'
      }, {
        header: 'Content helpfulness score',
        accessor: 'helpfulness',
        cell: this.helpfulnessCell,
        size: 'right',
        sorting: 'helpful'
      }];
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          popularTopics = _this$state.popularTopics,
          sorting = _this$state.sorting,
          isLoading = _this$state.isLoading;
      var table = (0, _preact.h)(_EmptyTable.default, {
        model: this.getModel()
      }, (0, _preact.h)(_Loader.Loader, {
        parentCustomClass: "dashboard-table-loader"
      }));

      if (!isLoading) {
        table = popularTopics.length > 0 ? (0, _preact.h)(_Table.default, {
          model: this.getModel(),
          rows: popularTopics,
          classes: ['popular_topics__table'],
          onSortChange: function onSortChange(attr) {
            if (attr === sorting.order) {
              return;
            }

            var newSorting = {
              order: attr,
              direction: 'desc'
            };

            _this2.fetchPopularTopics(newSorting);
          },
          sort: sorting,
          "data-element-name": "Popular topics table sort button",
          "data-track-type": "click"
        }) : (0, _preact.h)(_EmptyTable.default, {
          model: this.getModel()
        }, (0, _preact.h)(_EmptyResults.EmptyResults, null));
      }

      return (0, _preact.h)("div", {
        className: "dashboard-table-wrapper"
      }, table);
    }
  }]);
  return PopularTopicsTable;
}(_preact.Component);

var _default = PopularTopicsTable;
exports.default = _default;